// BD-1016: dashboard-wide "exclude disabled users" toggle. Session-only and off on
// every load, so a report opens with all accounts exactly as before. Module-level
// rather than React context because index.js issues its hydration queries above
// any provider it could render. useDashboardData folds it into every request as
// scope.excludeDisabled; the server drops Enabled = false users from each widget.
import { useSyncExternalStore } from 'react';

let excludeDisabled = false;
const listeners = new Set();

export function getExcludeDisabled() {
    return excludeDisabled;
}

export function setExcludeDisabled(value) {
    const next = Boolean(value);
    if (next === excludeDisabled) return;
    excludeDisabled = next;
    listeners.forEach((fn) => fn());
}

function subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

export function useExcludeDisabled() {
    return useSyncExternalStore(subscribe, getExcludeDisabled);
}
